import { translate } from "../i18n";

// Error types - MUST match packages/shared/interface.ts exactly
// Note: We define these here instead of importing from shared to avoid webpack resolution issues
// If shared/interface.ts changes, these must be updated to match
export enum ErrorTypes {
  UNRECOGNIZED_ERR = "UNRECOGNIZED_ERR",
  INCONCLUSIVE_CARD_INFO = "INCONCLUSIVE_CARD_INFO",
  INVALID_CAPTCHA = "INVALID_CAPTCHA",
  OASIS_API_ERROR = "OASIS_API_ERROR",
  ORDER_NOT_FOUND = "ORDER_NOT_FOUND"
}

export interface ApiErrorResponse {
  type: ErrorTypes;
  message: string;
  details?: unknown;
}

export type OrderDetailData = {
  orderId: string;
  isDraft: boolean;
};

export type OrdersData = {
  after: string;
  count: number;
  direction: string;
  isDraft: boolean;
};

export type RefreshTokenData = {
  accessToken: string;
};

export type IContestedReceiptItem = {
  rin: string;
  name: string;
  quantity: number;
};

export type ContestReceiptData = {
  orderId: string;
  originalReceipt: IContestedReceiptItem[];
  contestedReceipt: IContestedReceiptItem[];
};

export type ContestReceiptResponse = {
  responseCode: number;
  error?: string;
};

export type ProductData = {
  name: string;
};

export type RequestStatus = "loading" | "success" | "error" | "idle";

export const errorMessageMaps: Record<ErrorTypes, string> = {
  [ErrorTypes.UNRECOGNIZED_ERR]: translate("receiptsHome.unrecognizedError"),
  [ErrorTypes.INCONCLUSIVE_CARD_INFO]: translate(
    "receiptsHome.inconclusiveCardInfo"
  ),
  [ErrorTypes.INVALID_CAPTCHA]: translate("receiptsHome.invalidCaptcha"),
  [ErrorTypes.OASIS_API_ERROR]: translate("receiptsHome.oasisApiError"),
  [ErrorTypes.ORDER_NOT_FOUND]: translate("receiptsHome.orderNotFound"),
};

export enum ReceiptErrorType {
  NOT_FOUND = "NOT_FOUND",
  SERVER_ERROR = "SERVER_ERROR",
}

export type ReceiptErrorConfig = {
  title: string;
  message: string;
  retry: string;
  contactSupport: string;
  goBack?: string;
};

export const receiptErrorTypeMaps: Record<
  ReceiptErrorType,
  ReceiptErrorConfig
> = {
  [ReceiptErrorType.NOT_FOUND]: {
    title: translate("receiptError.notFound.title"),
    message: translate("receiptError.notFound.message"),
    retry: translate("receiptError.notFound.retry"),
    contactSupport: translate("receiptError.notFound.contactSupport"),
    goBack: translate("receiptError.notFound.goBack"),
  },
  [ReceiptErrorType.SERVER_ERROR]: {
    title: translate("receiptError.serverError.title"),
    message: translate("receiptError.serverError.message"),
    retry: translate("receiptError.serverError.retry"),
    contactSupport: translate("receiptError.serverError.contactSupport"),
  },
};
